<script setup>
import { ref, computed, watch } from 'vue';
import Input from 'dashboard/components-next/input/Input.vue';

const props = defineProps({
  message: {
    type: String,
    default: '',
  },
});

const emit = defineEmits(['update:variableValues']);

// Variable values for filling
const variableValues = ref({});

// Detect variables used in the message
const usedVariables = computed(() => {
  if (!props.message) return [];

  const regex = /\{\{(\w+)\}\}/g;
  const matches = [...props.message.matchAll(regex)];
  return [...new Set(matches.map(match => match[1]))];
});

// Format variable name for display
const formatVariable = name => `{{${name}}}`;

// Initialize variable values when detected variables change
watch(
  usedVariables,
  newVars => {
    const newValues = {};
    newVars.forEach(varName => {
      // Keep existing value if it exists
      newValues[varName] = variableValues.value[varName] || '';
    });
    variableValues.value = newValues;
  },
  { immediate: true }
);

// Emit variable values when they change
watch(
  variableValues,
  newValues => {
    emit('update:variableValues', newValues);
  },
  { deep: true }
);
</script>

<template>
  <div v-if="usedVariables.length > 0" class="flex flex-col gap-3">
    <div
      v-for="variable in usedVariables"
      :key="variable"
      class="flex flex-col gap-1"
    >
      <label class="text-xs font-medium text-n-slate-11">
        {{ formatVariable(variable) }}
      </label>
      <Input
        v-model="variableValues[variable]"
        type="text"
        :placeholder="`Default value for ${variable} (optional)`"
      />
    </div>
  </div>
</template>
